export const SET_TOKEN_USER = 'SET_TOKEN_USER'
export const LOGOUT_USER = 'LOGOUT_USER'
export const UPDATE_USER = 'UPDATE_USER'
